export default __webpack_public_path__ + "static/media/logo_jalisco_se_defiende_oscuro.4b7c28da.png";